var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 7,
    fill: "url(#paint0_linear_937_2450)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 9.83334C15.1882 9.83334 8.83301 16.1885 8.83301 24C8.83301 31.8115 15.1882 38.1667 22.9997 38.1667C30.8112 38.1667 37.1663 31.8115 37.1663 24C37.1663 16.1885 30.8112 9.83334 22.9997 9.83334ZM24.4163 30.9629V32.5H21.583V30.97C18.2694 30.4501 17.333 28.1338 17.333 26.8333H20.1663C20.1819 27.0359 20.3916 28.25 22.9997 28.25C24.9547 28.25 25.833 27.4213 25.833 26.8333C25.833 26.3743 25.833 25.4167 22.9997 25.4167C18.0697 25.4167 17.333 22.7533 17.333 21.1667C17.333 19.342 18.7908 17.506 21.583 17.0371V15.517H24.4163V17.0881C26.8728 17.6689 27.8163 19.7132 27.8163 21.1667H26.3997L24.983 21.1922C24.9632 20.6538 24.6784 19.75 22.9997 19.75C21.1594 19.75 20.1663 20.481 20.1663 21.1667C20.1663 21.6965 20.1663 22.5833 22.9997 22.5833C27.9297 22.5833 28.6663 25.2467 28.6663 26.8333C28.6663 28.658 27.2086 30.494 24.4163 30.9629Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_2450",
    x1: 23.5,
    y1: 0,
    x2: 23.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#695020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.ac1729c977be509d93b6a99f66dda419.svg";
export { ForwardRef as ReactComponent };